<template>
  <BackDrop @close-backdrop="close">
    <template v-slot:header>
      <h2>{{ $t("gamesBackdrop.title") }}</h2>
    </template>
    <template v-slot:main>
      <section style="margin-top: 40%">
        <div class="space-evenly" style="margin-bottom: 20px">
          <button
            class="btn btn-base btn-fill btn"
            @click="$router.push('wheel-play')"
          >
            {{ $t("home.wheelButton") }}
          </button>
          <button class="btn btn-base btn-fill" @click="$router.push('lottery')">
            {{ $t("home.lotteryButton") }}
          </button>
        </div>

        <div class="space-evenly" style="margin-bottom: 20px">
          <button
            v-if="linguaPortuguesa"
            class="btn btn-base btn-fill"
            @click="$router.push('never-have')"
          >
            {{ $t("home.neverHaveButton") }}
          </button>
          <button
            class="btn btn-base btn-fill"
            @click="$router.push('finger-selector')"
          >
            {{ $t("home.fingerSelectorButton") }}
          </button>
        </div>

        <div class="space-evenly" style="margin-bottom: 20px">
          <button
            class="btn btn-base btn-fill"
            @click="$router.push('where-is-it')"
          >
            {{ $t("home.whereIsItButton") }}
          </button>

          <button class="btn btn-base btn-fill" @click="$router.push('simon')">
            {{ $t("home.simonButton") }}
          </button>
        </div>

        <div
          class="space-evenly"
          v-if="!linguaPortuguesa"
          style="margin-bottom: 20px"
        >
          <button
            class="btn btn-base btn-fill"
            @click="$router.push('truth-or-drink')"
          >
            {{ $t("home.truthOrDrink") }}
          </button>
        </div>
      </section>
    </template>
  </BackDrop>
</template>

<script>
import { mixin } from "src/mixin";
import BackDrop from "src/components/BackDrop/BackDrop.vue";

export default {
  name: "MainGamesBackdrop",

  mixins: [mixin],

  components: {
    BackDrop,
  },

  methods: {
    close() {
      this.$emit("close-backdrop");
    },
  },
};
</script>

<style>
.space-evenly {
  display: flex;
  justify-content: space-evenly;
}
</style>
